export default {
  getApprovementStatus(state) {
    return state.approvementStatus;
  },
};
